import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

import { unassignedSymbol } from '~/utils'

import { type CustomerAttributeGroupSettingsInputCustomerAttributeGroup } from '../../utils'

const schema = z.object({
  customerAttributeGroups: z.array(
    z.object({
      id: z.string().optional(),
      name: z.string(),
      attachedCustomerAttributeGroupMap: z.record(
        z.string(),
        z.union([z.string(), z.null(), z.literal(unassignedSymbol)]),
      ),
      customerAttributes: z.array(
        z.object({
          id: z.string().optional(),
          name: z.string(),
          attachedCustomerAttributeMap: z.record(
            z.string(),
            z.union([z.number(), z.null(), z.literal(unassignedSymbol)]),
          ),
        }),
      ),
      showCustomizedKPI: z.boolean(),
    }),
  ),
}) satisfies z.ZodSchema<{
  customerAttributeGroups: CustomerAttributeGroupSettingsInputCustomerAttributeGroup[]
}>
export type InputValues = z.infer<typeof schema>
export const resolver = zodResolver(schema)
